<template>
  <div class="container">
    <b-navbar>
      <template slot="brand">
        <b-navbar-item
          class="has-text-black"
          tag="router-link"
          :to="{ path: '/' }"
        >
          <span class="has-text-weight-bold">Jake Offermann</span>
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item
          class="-page is-uppercase is-family-secondary"
          tag="router-link"
          :to="{ path: '/about' }"
        >
          About
        </b-navbar-item>
        <b-navbar-item
          class="-page is-uppercase is-family-secondary"
          tag="router-link"
          :to="{ path: '/contact' }"
        >
          Contact
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "AppNavbar"
};
</script>

<style scoped lang="scss"></style>
